import {Network} from './network_api';
import GameScene from './game_scene';

const STATES = {
    WHITE_TURN: 0,
    BLACK_TURN: 1,
    WAIT: 3,
    //
    WHITE_START_TURN: 4,
    BLACK_START_TURN: 5,
    WHITE_CHOICE_CHIP: 6,
    WHITE_CHOICE_CELL: 7,
    BLACK_CHOICE_CHIP: 8,
    BLACK_CHOICE_CELL: 9,
    END_GAME: 10,

    PLAYER_CHOICE_CHIP: 11,
    PLAYER_CHOICE_CELL: 12,
};

export const COLOR = {
    WHITE: 0,
    BLACK: 1
};

export default class Game {
    constructor(root, params, space) {
        this.gameScene = new GameScene(this, COLOR);

        root.addChild(this.gameScene);

        this.currentState = -1;

        space.s('ticker').on(dt => {
            //console.log(dt);
            this.gameScene.update(dt);

            this.gameLoop();
        });

        this.cellContent = [
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: COLOR.BLACK, count: 15},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: undefined, count: 0},
            {color: COLOR.WHITE, count: 15},
        ];

        this.cellCount = [
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ]


        this.baseCount = [0, 0];
        this.outCount = [0, 0];

        // this.chipInCell = [
        //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //     [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12]
        // ];

        this.currentDiceCombination = [[], []];
        this.currentDice = [];

        this.availableTurns = [];

        this.chosenStartCell = -1;
        this.chosenLastCell = -1;

        this.currentState = STATES.WAIT//STATES.WHITE_START_TURN;

        this.getInHead = false;

        this.turnLastMoves = [];

        //this.currentSide = COLOR.WHITE;

        this.playerColor = COLOR.WHITE;

        const gameId = params['game_id'] ? params['game_id'] : 0;
        const playerId = params[ 'user_current_id'] ? params[ 'user_current_id'] : 0;

        this.net = new Network(this, gameId, playerId);

        this.net.getGameState(() => {})
        //this.net.rollDice(() => {})

    }

    getBaseCount(color) {
        return this.baseCount[color];
    }

    isGameEnd() {
        let isEnd = false;
        this.baseCount.forEach(count => {
            if (count === 15) {
                isEnd = true;
            }
        })

        return isEnd;
    }

    resolveGameState(state) {

        this.cellCount[0] = state.gameBoard.white.board.slice();
        this.cellCount[1] = state.gameBoard.black.board.slice();

        this.baseCount[0] = state.gameBoard.white.base;
        this.baseCount[0] = state.gameBoard.black.base;

        this.outCount[0] = state.gameBoard.white.out;
        this.outCount[0] = state.gameBoard.black.out;

        this.gameScene.setChipsOnBoard(this.cellCount, this.baseCount, this.outCount);

        if (state.currentMoveNumber === 0) {
            const firstDice = state.diceFirst.slice();
            this.drawingFirstMove(firstDice, state.currentPlayer == this.net._playerId);
        }
        else {

            if (state.whitePlayer == this.net._playerId) {
                this.playerColor = COLOR.WHITE;
            }
            else {
                this.playerColor = COLOR.BLACK;
            }

            if (state.currentPlayer == this.net._playerId) {
                // Ходим мы
                this.net.rollDice(() => {});
            }
            else {
                //ходит оппонент
                this.net.pollingEnemyTurn()
            }
        }
    }

    drawingFirstMove(dice, winFirstTurn) {

        const rollDice = (done) => {
            this.gameScene.rollFirstDice(currentPare, prev, done);
        };

        const endRoll = () => {

            prev = dice[currentId];
            currentId++;
            if (currentId === dice.length) {
                if (winFirstTurn) {
                    // ходим мы первыми
                    this.playerColor = COLOR.WHITE;
                    this.net.rollDice(() => {});
                }
                else {
                    //ходит оппонент первым
                    this.playerColor = COLOR.BLACK;
                    this.gameScene.endTurn(this.playerColor);
                    this.net.pollingEnemyTurn()
                }
            }
            else {
                currentPare = dice[currentId];
                rollDice(() => {endRoll()});
            }

        };

        let currentId = 0;
        let currentPare = dice[currentId];
        let prev = [1, 1];
        rollDice(() => {endRoll()});
    }

    gameLoop() {
        switch (this.currentState) {
            case STATES.WHITE_TURN:
                break;
            case STATES.BLACK_TURN:
                break;
            case STATES.WAIT:
                break;
            // case STATES.WHITE_START_TURN:
            //
            //     this.gameScene.hideUndoButton();
            //
            //     this.turnLastMoves = [];
            //
            //     this.getInHead = false;
            //
            //     this.currentState = STATES.WAIT;
            //
            //     this.gameScene.startTurn(COLOR.WHITE);
            //
            //     let prevWhiteDice = this.currentDiceCombination[0].slice();
            //     this.randomizeDice(COLOR.WHITE);
            //     this.gameScene.showDice(COLOR.WHITE, prevWhiteDice, this.currentDiceCombination[0], () => {
            //
            //         if (this.isGameEnd()) {
            //             this.currentState = STATES.END_GAME;
            //         }
            //         else {
            //
            //             this.currentDice = this.currentDiceCombination[0].slice();
            //
            //             this.getAvailableTurns(COLOR.WHITE, this.currentDice);
            //
            //             if (this.availableTurns.length > 0) {
            //                 this.gameScene.showAvailableStartCell(this.availableTurns);
            //                 this.currentState = STATES.WHITE_CHOICE_CHIP;
            //             }
            //             else {
            //                 this.currentState = STATES.WAIT;
            //                 this.gameScene.sayCantTurn(COLOR.WHITE, () => {
            //                     this.currentState = STATES.BLACK_START_TURN;
            //                 })
            //             }
            //         }
            //     });
            //     break;
            //
            // case STATES.BLACK_START_TURN:
            //
            //     this.gameScene.hideUndoButton();
            //
            //     this.turnLastMoves = [];
            //
            //     this.getInHead = false;
            //
            //     this.currentState = STATES.WAIT;
            //
            //     this.gameScene.startTurn(COLOR.BLACK);
            //
            //     let prevBlackDice = this.currentDiceCombination[1].slice();
            //     this.randomizeDice(COLOR.BLACK);
            //     this.gameScene.showDice(COLOR.BLACK, prevBlackDice, this.currentDiceCombination[1], () => {
            //
            //         if (this.isGameEnd()) {
            //             this.currentState = STATES.END_GAME;
            //         }
            //         else {
            //
            //             this.currentDice = this.currentDiceCombination[1].slice();
            //
            //             this.getAvailableTurns(COLOR.BLACK, this.currentDice);
            //
            //             if (this.availableTurns.length > 0) {
            //                 this.gameScene.showAvailableStartCell(this.availableTurns);
            //                 this.currentState = STATES.BLACK_CHOICE_CHIP;
            //             }
            //             else {
            //                 this.currentState = STATES.WAIT;
            //                 this.gameScene.sayCantTurn(COLOR.BLACK, () => {
            //                     this.currentState = STATES.WHITE_START_TURN;
            //                 })
            //             }
            //         }
            //     });
            //     break;

            default:
                break;
        }
    }

    showEnemyTurn(data) {
        const enemyColor = (this.playerColor === COLOR.WHITE) ? COLOR.BLACK : COLOR.WHITE;

        const showEnemyMoves = (moves, done) => {
            if (moves.length && moves.length > 0) {
                let currentId = 0;
                let currentMove = moves[currentId];

                const doMove = () => {
                    this.gameScene.doMoveChip(enemyColor, currentMove[0], currentMove[1], false, () => {
                        currentId++;
                        if (currentId === moves.length) {
                            done();
                        }
                        else {
                            currentMove = moves[currentId];
                            doMove();
                        }
                    } )
                };

                doMove();
            }
            else {
                this.gameScene.sayCantTurn(enemyColor, done)
            }
        };

        let enemyDice = data.dice.slice();
        let enemyMove = data.lastMove;

        this.gameScene.startTurn(enemyColor);

        this.gameScene.showDice(enemyColor, [], enemyDice, () => {
            showEnemyMoves(enemyMove, () => {this.net.rollDice(() => {})});
        });
    }

    startPlayerTurn(availableMoves, dice) {

        this.gameScene.hideUndoButton();

        this.turnLastMoves = [];

        this.getInHead = false;

        this.currentState = STATES.WAIT;

        this.gameScene.startTurn(this.playerColor);

        let prevDice = this.currentDiceCombination[this.playerColor].slice();
        //this.randomizeDice(COLOR.BLACK);
        this.gameScene.showDice(this.playerColor, prevDice, dice, () => {

            if (this.isGameEnd()) {
                this.currentState = STATES.END_GAME;
            }
            else {

                this.currentDice = dice.slice();//this.currentDiceCombination[1].slice();

                this.getAvailableTurns(this.playerColor, this.currentDice);

                if (this.availableTurns.length > 0) {
                    this.gameScene.showAvailableStartCell(this.availableTurns);
                    this.currentState = STATES.PLAYER_CHOICE_CHIP;//STATES.BLACK_CHOICE_CHIP;
                }
                else {
                    this.currentState = STATES.WAIT;
                    this.gameScene.sayCantTurn(this.playerColor, () => {
                        // this.net.sendTurnMove(() => {
                        //     this.net.pollingEnemyTurn();
                        // })//this.currentState = STATES.WHITE_START_TURN;
                        this.passTurnEnemy();
                    })
                }
            }
        });
    }

    passTurnEnemy() {

        const enemyColor = (this.playerColor === COLOR.WHITE) ? COLOR.BLACK : COLOR.WHITE;

        this.currentState = STATES.WAIT;

        this.gameScene.startTurn(enemyColor);

        this.net.sendTurnMove(this.turnLastMoves, () => {
            setTimeout(() => {this.net.pollingEnemyTurn()}, 1000);
            // this.net.pollingEnemyTurn();
        })
    }

    randomizeDice(color) {

        let first = Math.floor(Math.random() * 6 + 1);
        let second = Math.floor(Math.random() * 6 + 1);

        let dice = [first, second];
        if (first === second) {
            for (let i = 0; i < 2; ++i) {
                dice.push(second);
            }
        }

        if (color === COLOR.WHITE) {
            this.currentDiceCombination[0] = dice.slice();
        }
        else {
            this.currentDiceCombination[1] = dice.slice();
        }
    }

    getDiceValue(color) {
        let first = Math.floor(Math.random() * 6 + 1);
        let second = Math.floor(Math.random() * 6 + 1);

        return [first, second];
    }

    canOutChips(color) {
        let canOut = true;

        // if (color === COLOR.WHITE) {
        //     for (let i = 0; i < 18; ++i) {
        //         if (this.cellContent[i].color === COLOR.WHITE) {
        //             canOut = false;
        //             break;
        //         }
        //     }
        // }
        // else {
        //     for (let i = 0; i < 6; ++i) {
        //         if (this.cellContent[i].color === COLOR.BLACK) {
        //             canOut = false;
        //             break;
        //         }
        //     }
        //     if (canOut) {
        //         for (let i = 12; i < 24; ++i) {
        //             if (this.cellContent[i].color === COLOR.BLACK) {
        //                 canOut = false;
        //                 break;
        //             }
        //         }
        //     }
        // }

        if (color === COLOR.WHITE) {
            for (let i = 6; i < 24; ++i) {
                if (this.cellCount[0][i] > 0) {
                    canOut = false;
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < 12; ++i) {
                if (this.cellCount[1][i] > 0) {
                    canOut = false;
                    break;
                }
            }
            if (canOut) {
                for (let i = 18; i < 24; ++i) {
                    if (this.cellCount[1][i] > 0) {
                        canOut = false;
                        break;
                    }
                }
            }
        }

        return canOut;
    };

    undoLastTurn() {
        let id = 0;

        let currentColor = (this.currentState === STATES.WHITE_CHOICE_CHIP || this.currentState === STATES.WHITE_CHOICE_CELL) ? COLOR.WHITE : COLOR.BLACK;
        this.currentState = STATES.WAIT;

        // this.turnLastMoves = [
        //     [2, 4],
        //     [3, 6],
        //     [4, 6]
        // ]

        this.turnLastMoves.reverse();

        let find = false;
        while (id < this.turnLastMoves.length) {
            find = false;

            let currentMove = this.turnLastMoves[id];
            for (let i = id + 1; i < this.turnLastMoves.length; ++i) {
                let compMove = this.turnLastMoves[i];
                if (currentMove[0] === compMove[1]) {

                    currentMove[0] = compMove[0];
                    this.turnLastMoves.splice(i, 1);

                    find = true;
                    break;
                }
            }

            if (!find) {
                id++
            }

        }

        this.gameScene.hideUndoButton();

        //this.turnLastMoves.reverse();
        console.log('RESULT FILTER: ', this.turnLastMoves, currentColor);

        for (let i = 0; i < this.turnLastMoves.length; ++i) {

            this.cellContent[this.turnLastMoves[i][1]].count--;
            if (this.cellContent[this.turnLastMoves[i][1]].count === 0 ) {
                this.cellContent[this.turnLastMoves[i][1]].color = undefined;
            }
            this.cellContent[this.turnLastMoves[i][0]].color = currentColor;
            this.cellContent[this.turnLastMoves[i][0]].count++;

            if (i < this.turnLastMoves.length - 1) {
                this.gameScene.doMoveChip(currentColor, this.turnLastMoves[i][1], this.turnLastMoves[i][0], true)
            }
            else {
                this.gameScene.doMoveChip(currentColor, this.turnLastMoves[i][1], this.turnLastMoves[i][0], true, () => {

                    this.getInHead = false;
                    this.turnLastMoves = [];
                    this.currentDice = this.currentDiceCombination[currentColor].slice();

                    this.getAvailableTurns(currentColor, this.currentDice);
                    this.gameScene.showAvailableStartCell(this.availableTurns);
                    if (currentColor === COLOR.WHITE) {
                        this.currentState = STATES.WHITE_CHOICE_CHIP;
                    }
                    else {
                        this.currentState = STATES.BLACK_CHOICE_CHIP;
                    }
                })
            }
        }
    }

    getAvailableTurns(color, dice) {

        this.availableTurns = [];

        if (color === COLOR.WHITE) {
            for (let cell = 0; cell < 24;/*this.cellContent.length;*/ ++cell) {

                if (cell === 23 && this.getInHead) {
                    continue;
                }
                if (this.cellCount[0][cell] > 0) {//(this.cellContent[cell].color !== undefined && this.cellContent[cell].color === COLOR.WHITE) {
                    let sumDice = 0;
                    let useDice = [];
                    for (let d = 0; d < dice.length; ++d) {
                        sumDice += dice[d];
                        useDice.push(d);
                        let endCell = cell - dice[d];
                        if (endCell < 0) {endCell = 24}
                        //console.log(d, dice[d], cell, endCell);
                        let endFree = endCell < 24 && this.cellCount[1][endCell] === 0;//this.cellContent[endCell].color !== COLOR.BLACK;
                        let canOut = this.canOutChips(COLOR.WHITE) && endCell >= 24;
                        if (endFree || canOut) {
                            this.availableTurns.push([cell, endCell, [d]]);
                        }

                        if (d > 0) {
                            endCell = cell - sumDice;
                            if (endCell < 0) {endCell = 24}
                            let endFree = endCell < 24 && this.cellCount[1][endCell] === 0;//this.cellContent[endCell].color !== COLOR.BLACK;
                            let canOut = this.canOutChips(COLOR.WHITE) && endCell >= 24;
                            //console.log(sumDice, cell, endCell, useDice);
                            if (endFree || canOut) {
                                this.availableTurns.push([cell, endCell, useDice.slice()]);
                            }
                        }
                    }
                }
            }
        }
        else {
            for (let cell = 0; cell < 24/*this.cellContent.length*/; ++cell) {

                if (cell === 11 && this.getInHead) {
                    continue;
                }
                if (this.cellCount[1][cell] > 0) {//(this.cellContent[cell].color !== undefined && this.cellContent[cell].color === COLOR.BLACK) {
                    let sumDice = 0;
                    let useDice = [];
                    for (let d = 0; d < dice.length; ++d) {
                        sumDice += dice[d];
                        useDice.push(d);
                        let endCell = cell - dice[d] - (cell > 11 ? 24 : 0);
                        //if (endCell < 0) endCell += 24;
                        let realCell = (endCell < -11) ? 25 : (endCell < 0) ? endCell + 24 : endCell;//(endCell > 35) ? 25 : endCell % 24 | 0;
                        //console.log(d, dice[d], cell, endCell);
                        let endFree = endCell > -12 && this.cellCount[0][realCell] === 0;//this.cellContent[realCell].color !== COLOR.WHITE;
                        let canOut = this.canOutChips(COLOR.BLACK) && endCell < -11;
                        if (endFree || canOut) {
                            this.availableTurns.push([cell, realCell, [d]]);
                        }

                        if (d > 0) {
                            // endCell = cell + sumDice + (cell < 12 ? 24 : 0);
                            // let realCell = (endCell > 35) ? 25 : endCell % 24 | 0;
                            // let endFree = endCell < 36 && this.cellContent[realCell].color !== COLOR.WHITE;
                            // let canOut = this.canOutChips(COLOR.BLACK) && endCell >= 24;
                            //console.log(3, sumDice, cell, endCell);
                            let endCell = cell - sumDice - (cell > 11 ? 24 : 0);
                            let realCell = (endCell < -11) ? 25 : (endCell < 0) ? endCell + 24 : endCell;//(endCell > 35) ? 25 : endCell % 24 | 0;
                            let endFree = endCell > -12 && this.cellCount[0][realCell] === 0;//this.cellContent[realCell].color !== COLOR.WHITE;
                            let canOut = this.canOutChips(COLOR.BLACK) && endCell < -11;
                            if (endFree || canOut) {
                                this.availableTurns.push([cell, realCell, useDice.slice()]);
                            }
                        }
                    }
                }
            }
        }

    }

    choiceCell(cellId) {
        switch (this.currentState) {

            case STATES.PLAYER_CHOICE_CHIP:

                this.chosenStartCell = -1;

                for (let i = 0; i < this.availableTurns.length; ++i) {
                    if (this.availableTurns[i][0] === cellId) {
                        this.chosenStartCell = cellId;
                        break;
                    }
                }

                if (this.chosenStartCell >= 0) {
                    this.currentState = STATES.PLAYER_CHOICE_CELL;

                    this.gameScene.showAvailableEndCell(
                        this.availableTurns.filter(turn => {
                            return turn[0] === this.chosenStartCell;
                        }),
                        this.chosenStartCell
                    )
                }

                break;

            case STATES.PLAYER_CHOICE_CELL:

                if (cellId === this.chosenStartCell) {
                    this.chosenStartCell = -1;
                    this.gameScene.showAvailableStartCell(this.availableTurns);
                    this.currentState = STATES.PLAYER_CHOICE_CHIP;
                }
                else {

                    if (this.chosenStartCell === 23 && this.playerColor === COLOR.WHITE ||
                        this.chosenStartCell === 11 && this.playerColor === COLOR.BLACK) {
                        this.getInHead = true;
                    }

                    let useDice = [];

                    this.chosenLastCell = -1;
                    for (let i = 0; i < this.availableTurns.length; ++i) {
                        if (this.availableTurns[i][0] === this.chosenStartCell && this.availableTurns[i][1] === cellId) {
                            this.chosenLastCell = cellId;
                            useDice = this.availableTurns[i][2];
                            //console.log(this.availableTurns[i]);
                            break;
                        }
                    }

                    if (this.chosenLastCell >= 0) {

                        this.turnLastMoves.push([this.chosenStartCell, this.chosenLastCell]);

                        this.gameScene.doMoveChip(this.playerColor, this.chosenStartCell, this.chosenLastCell, false, () => {

                            console.log(this.chosenStartCell);

                            this.cellCount[this.playerColor][this.chosenStartCell]--;
                            if (this.chosenLastCell > 23) {
                                this.baseCount[this.playerColor]++;
                            }
                            else {
                                this.cellCount[this.playerColor][this.chosenLastCell]++;
                            }

                            console.log(this.chosenStartCell);

                            for (let i = useDice.length - 1; i >=0; --i ) {
                                this.currentDice.splice(useDice[i], 1);
                            }

                            console.log(this.cellCount, this.chosenStartCell, this.chosenLastCell);

                            //console.log(this.currentDice, useDice);

                            if (this.currentDice.length > 0) {
                                this.getAvailableTurns(this.playerColor, this.currentDice);
                                if (this.availableTurns.length > 0) {

                                    this.gameScene.showUndoButton();

                                    this.gameScene.showAvailableStartCell(this.availableTurns);
                                    this.currentState = STATES.PLAYER_CHOICE_CHIP;
                                }
                                else {
                                    this.currentState = STATES.WAIT//STATES.BLACK_START_TURN;
                                    this.gameScene.endTurn(this.playerColor);
                                    this.passTurnEnemy();
                                }
                            }
                            else {
                                this.currentState = STATES.WAIT;//this.currentState = STATES.BLACK_START_TURN;
                                this.gameScene.endTurn(this.playerColor);
                                this.passTurnEnemy();
                            }

                        })
                    }
                }

                break;


            case STATES.WHITE_CHOICE_CHIP:

                console.log('AAAAAAAAAAAAA WHITE');

                this.chosenStartCell = -1;

                for (let i = 0; i < this.availableTurns.length; ++i) {
                    if (this.availableTurns[i][0] === cellId) {
                        this.chosenStartCell = cellId;
                        break;
                    }
                }

                if (this.chosenStartCell >= 0) {
                    this.currentState = STATES.WHITE_CHOICE_CELL;

                    this.gameScene.showAvailableEndCell(
                        this.availableTurns.filter(turn => {
                            return turn[0] === this.chosenStartCell;
                        }),
                        this.chosenStartCell
                    )
                }

                break;
            case STATES.WHITE_CHOICE_CELL:

                if (cellId === this.chosenStartCell) {
                    this.chosenStartCell = -1;
                    this.gameScene.showAvailableStartCell(this.availableTurns);
                    this.currentState = STATES.WHITE_CHOICE_CHIP;
                }
                else {

                    if (this.chosenStartCell === 23) {
                        this.getInHead = true;
                    }

                    let useDice = [];

                    this.chosenLastCell = -1;
                    for (let i = 0; i < this.availableTurns.length; ++i) {
                        //console.log(this.availableTurns[i], this.chosenStartCell, i);
                        if (this.availableTurns[i][0] === this.chosenStartCell && this.availableTurns[i][1] === cellId) {
                            this.chosenLastCell = cellId;
                            useDice = this.availableTurns[i][2];
                            //console.log(this.availableTurns[i]);
                            break;
                        }
                    }

                    if (this.chosenLastCell >= 0) {

                        this.turnLastMoves.push([this.chosenStartCell, this.chosenLastCell]);

                        this.gameScene.doMoveChip(COLOR.WHITE, this.chosenStartCell, this.chosenLastCell, false, () => {

                            // this.cellContent[this.chosenStartCell].count--;
                            // if (this.cellContent[this.chosenStartCell].count === 0 ) {
                            //     this.cellContent[this.chosenStartCell].color = undefined;
                            // }
                            // if (this.chosenLastCell > 23) {
                            //     this.baseCount[COLOR.WHITE]++;
                            // }
                            // else {
                            //     this.cellContent[this.chosenLastCell].color = COLOR.WHITE;
                            //     this.cellContent[this.chosenLastCell].count++;
                            // }
                            this.cellCount[0][this.chosenStartCell]--;
                            if (this.chosenLastCell > 23) {
                                this.baseCount[COLOR.WHITE]++;
                            }
                            else {
                                this.cellCount[0][this.chosenLastCell]++;
                            }

                            for (let i = useDice.length - 1; i >=0; --i ) {
                                this.currentDice.splice(useDice[i], 1);
                            }

                            console.log(this.currentDice, useDice);

                            if (this.currentDice.length > 0) {
                                this.getAvailableTurns(COLOR.WHITE, this.currentDice);
                                if (this.availableTurns.length > 0) {

                                    this.gameScene.showUndoButton();

                                    this.gameScene.showAvailableStartCell(this.availableTurns);
                                    this.currentState = STATES.WHITE_CHOICE_CHIP;
                                }
                                else {
                                    this.currentState = STATES.BLACK_START_TURN;
                                }
                            }
                            else {
                                this.currentState = STATES.BLACK_START_TURN;
                            }

                        })
                    }
                }

                break;
            case STATES.BLACK_CHOICE_CHIP:
                this.chosenStartCell = -1;

                for (let i = 0; i < this.availableTurns.length; ++i) {
                    if (this.availableTurns[i][0] === cellId) {
                        this.chosenStartCell = cellId;
                        break;
                    }
                }

                if (this.chosenStartCell >= 0) {
                    this.currentState = STATES.BLACK_CHOICE_CELL;

                    this.gameScene.showAvailableEndCell(
                        this.availableTurns.filter(turn => {
                            return turn[0] === this.chosenStartCell;
                        }),
                        this.chosenStartCell
                    )
                }
                break;
            case STATES.BLACK_CHOICE_CELL:
                if (cellId === this.chosenStartCell) {
                    this.chosenStartCell = -1;
                    this.gameScene.showAvailableStartCell(this.availableTurns);
                    this.currentState = STATES.BLACK_CHOICE_CHIP;
                }
                else {

                    if (this.chosenStartCell === 11) {
                        this.getInHead = true;
                    }

                    let useDice = [];

                    this.chosenLastCell = -1;
                    for (let i = 0; i < this.availableTurns.length; ++i) {
                        //console.log(this.availableTurns[i], this.chosenStartCell, i);
                        if (this.availableTurns[i][0] === this.chosenStartCell && this.availableTurns[i][1] === cellId) {
                            this.chosenLastCell = cellId;
                            useDice = this.availableTurns[i][2]
                            break;
                        }
                    }

                    if (this.chosenLastCell >= 0) {

                        this.turnLastMoves.push([this.chosenStartCell, this.chosenLastCell]);

                        this.gameScene.doMoveChip(COLOR.BLACK, this.chosenStartCell, this.chosenLastCell, false, () => {

                            // this.cellContent[this.chosenStartCell].count--;
                            // if (this.cellContent[this.chosenStartCell].count === 0 ) {
                            //     this.cellContent[this.chosenStartCell].color = undefined;
                            // }
                            // if (this.chosenLastCell > 23) {
                            //     this.baseCount[COLOR.BLACK]++;
                            // }
                            // else {
                            //     this.cellContent[this.chosenLastCell].color = COLOR.BLACK;
                            //     this.cellContent[this.chosenLastCell].count++;
                            // }

                            this.cellCount[1][this.chosenStartCell]--;
                            if (this.chosenLastCell > 23) {
                                this.baseCount[COLOR.BLACK]++;
                            }
                            else {
                                this.cellCount[1][this.chosenLastCell]++;
                            }

                            for (let i = useDice.length - 1; i >=0; --i ) {
                                this.currentDice.splice(useDice[i], 1);
                            }

                            if (this.currentDice.length > 0) {
                                this.getAvailableTurns(COLOR.BLACK, this.currentDice);
                                if (this.availableTurns.length > 0) {

                                    this.gameScene.showUndoButton();

                                    this.gameScene.showAvailableStartCell(this.availableTurns);
                                    this.currentState = STATES.BLACK_CHOICE_CHIP;
                                }
                                else {
                                    this.currentState = STATES.WHITE_START_TURN;
                                }
                            }
                            else {
                                this.currentState = STATES.WHITE_START_TURN;
                            }

                        })
                    }
                }
                break;
            case STATES.WAIT:
                break;
            default:
                break;
        }
    }

}



// WEBPACK FOOTER //
// ./src/game.es6